/**
 * SD: Sticky Info-Bereich auf der Product Page.
 * Ist der Info-Bereich höher als das Fenster, würde er mit position: sticky unten abgeschnitten.
 * Darum wird hier gemessen, wie viel Platz bleibt (Fensterhöhe minus Höhe des Bereichs).
 * sd-product.css nutzt den Wert als top, wenn er kleiner ist als die Header-Höhe:
 * Der Bereich scrollt dann erst mit, bis sein unteres Ende sichtbar ist, und bleibt dann stehen.
 */
const details = document.querySelector('.product-information .product-details.sticky-content--desktop');

if (details instanceof HTMLElement) {
  const update = () => {
    details.style.setProperty('--sd-sticky-fit', `${window.innerHeight - details.offsetHeight}px`);
  };

  new ResizeObserver(update).observe(details);
  window.addEventListener('resize', update, { passive: true });
  update();
}

/**
 * SD: Akkordeons (More Details, Sizing …) weich auf- und zuklappen, immer nur eins offen.
 * Horizons <details> springt sonst sofort auf. Hier wird die Höhe des Inhalts animiert;
 * beim Schließen bleibt <details> offen, bis die Animation fertig ist (.is-closing dreht den Chevron schon zurück).
 * Kein Ein-/Ausblenden der Deckkraft: Das lässt Text in manchen Browsern beim Animieren leicht verrutschen.
 */
const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
const accordionTiming = { duration: 400, easing: 'cubic-bezier(0.25, 0.1, 0.25, 1)' };

/**
 * @param {HTMLDetailsElement} details
 * @param {boolean} open
 */
const toggleAccordion = (details, open) => {
  const content = details.querySelector(':scope > .details-content');
  const isOpen = details.open && !details.classList.contains('is-closing');
  if (open === isOpen) return;

  if (!(content instanceof HTMLElement) || reduceMotion.matches) {
    details.classList.remove('is-closing');
    details.open = open;
    return;
  }

  // Aktuelle Höhe messen, bevor eine laufende Animation gestoppt wird (schnelles Doppelklicken)
  const startHeight = details.open ? content.offsetHeight : 0;
  content.getAnimations().forEach((animation) => animation.cancel());

  details.classList.toggle('is-closing', !open);
  details.open = true;

  const endHeight = open ? content.offsetHeight : 0;
  // Innenabstand mitanimieren, sonst springt der Inhalt am Ende um das Padding
  const { paddingTop, paddingBottom } = getComputedStyle(content);
  /** @param {number} height */
  const frame = (height) => ({
    boxSizing: 'border-box',
    height: `${height}px`,
    paddingTop: height ? paddingTop : '0px',
    paddingBottom: height ? paddingBottom : '0px',
    overflow: 'hidden',
  });
  const animation = content.animate([frame(startHeight), frame(endHeight)], accordionTiming);

  animation.onfinish = () => {
    if (!open) {
      details.open = false;
      details.classList.remove('is-closing');
    }
  };
};

document.addEventListener('click', (event) => {
  if (event.defaultPrevented) return;

  const summary = /** @type {Element} */ (event.target).closest('.product-information .accordion summary');
  const details = summary?.parentElement;
  if (!(details instanceof HTMLDetailsElement)) return;

  event.preventDefault();
  const open = !details.open || details.classList.contains('is-closing');

  // Beim Öffnen die anderen Zeilen desselben Akkordeons schließen
  if (open) {
    for (const other of details.closest('.accordion')?.querySelectorAll('details') ?? []) {
      if (other !== details && other instanceof HTMLDetailsElement) toggleAccordion(other, false);
    }
  }

  toggleAccordion(details, open);
});

/**
 * SD: Ladezustand für "Add to cart": .sd-loading zeigt den weißen Ladekreis (sd-product.css),
 * bis Shopify den Artikel in den Warenkorb gelegt hat (oder ein Fehler kam).
 */
document.addEventListener('submit', (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || !form.matches('.product-information [data-type="add-to-cart-form"]')) return;

  const button = form.querySelector('.add-to-cart-button');
  if (!(button instanceof HTMLElement)) return;

  button.classList.add('sd-loading');
  button.setAttribute('aria-busy', 'true');

  const done = () => {
    button.classList.remove('sd-loading');
    button.removeAttribute('aria-busy');
    clearTimeout(fallback);
  };
  // Sicherheitsnetz, falls keine Antwort kommt
  const fallback = setTimeout(done, 8000);

  document.addEventListener(
    'shopify:cart:lines-update',
    (/** @type {Event & {promise?: Promise<unknown>}} */ update) => {
      Promise.resolve(update.promise).finally(done);
    },
    { once: true }
  );
  // capture: vor Horizons Formular-Handler, der das Update-Ereignis sofort auslöst
}, true);
